import React, { useState } from 'react';
import { Modal } from "@/components/ui/modal";
import { Button } from "@/components/ui/button";
import { Textarea } from "@/components/ui/textarea";

interface ReviewModalProps {
    isOpen: boolean;
    onClose: () => void;
    onAccept: (note: string) => void;
    onReject: (note: string) => void;
}

export const ReviewModal: React.FC<ReviewModalProps> = ({
    isOpen,
    onClose,
    onAccept,
    onReject,
}) => {
    const [reviewNote, setReviewNote] = useState('');

    const handleAccept = () => {
        onAccept(reviewNote);
        setReviewNote('');
        onClose();
    };

    const handleReject = () => {
        onReject(reviewNote);
        setReviewNote('');
        onClose();
    };

    const handleClose = () => {
        setReviewNote('');
        onClose();
    };

    return (
        <Modal isOpen={isOpen} onClose={handleClose} title="Complete review">
            <div className="space-y-4 p-6">
                <p className="text-sm text-gray-600">
                    Write an optional note and choose whether to accept or reject.
                </p>

                <Textarea
                    placeholder="Aggiungi una nota (opzionale)"
                    value={reviewNote}
                    onChange={(e) => setReviewNote(e.target.value)}
                    className="min-h-[80px]"
                />

                <div className="flex gap-3 justify-end pt-4">
                    <Button
                        onClick={handleReject}
                        variant="outline"
                        size="sm"
                    >
                        Reject
                    </Button>
                    <Button
                        onClick={handleAccept}
                        size="sm"
                    >
                        Accept
                    </Button>
                </div>
            </div>
        </Modal>
    );
};
